import { createSlider } from '@theme/theme-global';

if (!customElements.get('motif-collections-slider')) {
  class MotifCollectionsSlider extends HTMLDivElement {
    connectedCallback() {
      // Choose once per page load, before Swiper measures the slides.
      const usedProducts = new Set();
      this.querySelectorAll('[data-motif-card]').forEach((card) => {
        const images = Array.from(card.querySelectorAll('[data-motif-image]'));
        const unused = images.filter((image) => !usedProducts.has(image.dataset.productId));
        const pool = unused.length ? unused : images;
        const selected = pool[Math.floor(Math.random() * pool.length)];
        const chosen = images.indexOf(selected);
        if (selected) usedProducts.add(selected.dataset.productId);
        images.forEach((image, index) => { image.hidden = index !== chosen; });
      });
      const generation = (this.generation ?? 0) + 1;
      this.generation = generation;
      createSlider(this, JSON.parse(this.dataset.params)).then((slider) => {
        if (!this.isConnected || this.generation !== generation) {
          slider?.destroy?.(true, true);
          return;
        }
        this.slider = slider;
        this.onFocus = (event) => {
          const slide = event.target.closest('.swiper-slide');
          if (slide) slider.slideTo(Array.from(slide.parentElement.children).indexOf(slide));
        };
        this.addEventListener('focusin', this.onFocus);
      }).catch((error) => console.error('Motivkollektionen: Slider konnte nicht geladen werden.', error));
    }
    disconnectedCallback() {
      this.generation = (this.generation ?? 0) + 1;
      if (this.onFocus) this.removeEventListener('focusin', this.onFocus);
      this.slider?.destroy?.(true, true);
      this.slider = null;
    }
  }
  customElements.define('motif-collections-slider', MotifCollectionsSlider, { extends: 'div' });
}
